import { render } from "./ArtsDeptView.vue?vue&type=template&id=40d96eb0"
import script from "./ArtsDeptView.vue?vue&type=script&lang=js"
export * from "./ArtsDeptView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__